import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { GermplasmDetailsContext } from '../germplasm-details.context';
import { GermplasmList } from '../../shared/germplasm/model/germplasm.model';
import { ParamContext } from '../../shared/service/param.context';
import { UrlService } from '../../shared/service/url.service';
import { Program } from '../../shared/program/model/program';
import { GermplasmDetailsPopupService } from '../germplasm-details-popup.service';
import { GermplasmListUrlService } from '../../shared/germplasm-list/service/germplasm-list.url.services';

@Component({
    selector: 'jhi-lists-pane',
    templateUrl: './lists-pane.component.html'
})
export class ListsPaneComponent implements OnInit {

    germplasmLists: GermplasmList[] = [];

    constructor(public languageservice: JhiLanguageService,
                public translateService: TranslateService,
                public urlService: UrlService,
                private germplasmService: GermplasmService,
                public germplasmDetailsContext: GermplasmDetailsContext,
                public paramContext: ParamContext,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService,
                public germplasmListUrlService: GermplasmListUrlService) {
    }

    ngOnInit(): void {
        this.germplasmService.getGermplasmListsByGid(this.germplasmDetailsContext.gid).toPromise().then((value) => {
            this.germplasmLists = value;
        });
    }

    isClickable(germplasmList: GermplasmList) {
        return this.paramContext.programUUID === germplasmList.programUUID;
    }

    getSafeUrl(listId: number, listName: string) {
        return this.germplasmListUrlService.getUrl(listId, listName);
    }

    closeDialog() {
        if (this.germplasmDetailsPopupService) {
            this.germplasmDetailsPopupService.close();
        }
    }
}
